import React from 'react';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';
import InvoiceOrder from './InvoiceOrder';
import {Button} from 'react-bootstrap';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {FieldArray} from 'formik';
import styles from './styles.module.scss';

export default function GridUnit({values, valuesSet, viewMode}) {
  const prefix = 'invoice-orders-popup-edit';

  return (
    <div className={styles.popupEditRowGrid}>
      <div className={viewMode ? styles.headerView : styles.headerEdit}>
        <div className={styles.headerCell}>
          <FormattedMessage id={`${prefix}-column-days`} defaultMessage="Days"/>
        </div>
        <div className={styles.headerCell}>
          <FormattedMessage id={`${prefix}-column-hours`} defaultMessage="Hours"/>
        </div>
        <div className={styles.headerCell}>
          <FormattedMessage id={`${prefix}-column-description`} defaultMessage="Description"/>
        </div>
        <div className={styles.headerCell}>
          <FormattedMessage id={`${prefix}-column-amount`} defaultMessage="Amount"/>
        </div>
        <div className={styles.headerCell}>
          <FormattedMessage id={`${prefix}-column-vat`} defaultMessage="VAT"/>
        </div>
        {!viewMode && <div className={styles.headerCell}/>}
      </div>
      <FieldArray name={'invoiceOrderData.lines'}>
        {({remove, push}) => {
          return (
            <>
              <div className={styles.gridBody}>
                {(values.invoiceOrderData.lines.length > 0) && values.invoiceOrderData.lines.map((sets, index) => (
                  <div key={index}>
                    <InvoiceOrder
                      days={`invoiceOrderData.lines.${index}.days`}
                      hours={`invoiceOrderData.lines.${index}.hours`}
                      description={`invoiceOrderData.lines.${index}.description`}
                      amount={`invoiceOrderData.lines.${index}.amount`}
                      vatIncluded={`invoiceOrderData.lines.${index}.vatIncluded`}
                      viewMode={viewMode}
                      buttonRemove={!viewMode &&
                        <Button
                          className={classNames('btn btn-icon btn-light btn-sm', styles.buttonRemove)}
                          onClick={() => {
                            remove(index);
                          }}
                        >
                          <img
                            src={toAbsoluteUrl('/media/svg/Cross_brandColor.svg')}
                            alt="remove"
                            className="w-20px"
                          />
                        </Button>
                      }
                    />
                  </div>
                ))
                }
              </div>
              {!viewMode &&
                <Button
                  className="btn-sm mx-auto mt-2 custom-send-button d-flex justify-content-center text-nowrap"
                  onClick={() => {
                    push(valuesSet);
                  }}
                >
                  <img
                    src={toAbsoluteUrl('/media/svg/Plus_square_white.svg')}
                    alt="add"
                    className="mr-2 w-20px"
                  />
                  <FormattedMessage
                    id="invoice-orders-popup-edit-addRow"
                    defaultMessage="Add row"
                  />
                </Button>
              }
            </>
          );
        }}
      </FieldArray>
    </div>
  );
}
